var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvax = function SvgAvax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D74F49",
    rx: 50
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    strokeOpacity: 0.2,
    rx: 49.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avax_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.115 57.763c1.681-2.903 4.394-2.903 6.075 0L83.658 76.14c1.68 2.904.305 5.273-3.057 5.273H59.513c-3.324 0-4.7-2.37-3.057-5.273zM46.867 22.387c1.681-2.904 4.355-2.904 6.037 0l2.33 4.202 5.501 9.666a10.04 10.04 0 0 1 0 8.748L42.283 76.98a9.7 9.7 0 0 1-7.565 4.432h-15.32c-3.361 0-4.736-2.33-3.056-5.273z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avax_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.625 15.625h68.75v68.75h-68.75z"
  })))));
};
export default SvgAvax;